import { useEffect, useMemo } from 'react';
import useLocalStorageStateBase from './useLocalStorageStateBase';
export default function createLocalStorageStateHook(key, defaultValue) {
    const setValueFunctions = [];
    return function useLocalStorageStateHook() {
        const [value, setValue, isPersistent] = useLocalStorageStateBase(key, defaultValue);
        const setValueAll = useMemo(() => {
            const fn = (newValue) => {
                for (const setValueFunction of setValueFunctions) {
                    setValueFunction(newValue);
                }
            };
            fn.reset = () => {
                for (const setValueFunction of setValueFunctions) {
                    setValueFunction.reset();
                }
            };
            return fn;
        }, []);
        useEffect(() => {
            setValueFunctions.push(setValue);
            return () => void setValueFunctions.splice(setValueFunctions.indexOf(setValue), 1);
        }, [setValue]);
        return [value, setValueAll, isPersistent];
    };
}
